import GeoPicker from "components/shared/geopicker";
import React from "react";

export default function PointIntersectionsFilters(props) {
    const setParameterFilter = ({ name, value }) => {
        const { parametersObject } = props.values;
        parametersObject[name] = value;
        props.setFilter({ name: "parametersObject", value: parametersObject });
    };

    return (
        <>
            <div className="mb-md-0 report__filters--mr">
                <div className="row">
                    <GeoPicker
                        isClearable
                        withoutRadius
                        inputClassName="form-control form-control-sm bg-white"
                        inputPlaceholder="Первая точка"
                        name="firstLocation"
                        switchMap={props.switchMap}
                        onChange={setParameterFilter}
                        value={props.values.parametersObject.firstLocation}
                    />
                </div>
            </div>
            <div className="mb-md-0 report__filters--mr">
                <div className="row">
                    <GeoPicker
                        isClearable
                        withoutRadius
                        inputClassName="form-control form-control-sm bg-white"
                        inputPlaceholder="Вторая точка"
                        name="secondLocation"
                        switchMap={props.switchMap}
                        onChange={setParameterFilter}
                        value={props.values.parametersObject.secondLocation}
                    />
                </div>
            </div>
            <div className="mb-md-0 report__filters--mr">
                <div className="input-group input-group-sm">
                    <div className="input-group-prepend">
                        <span className="input-group-text">Радиус, м</span>
                    </div>
                    <input
                        type="number"
                        placeholder="1 000 - 20 000"
                        className="form-control form-control-sm"
                        value={props.values.parametersObject?.radius}
                        min={1000}
                        max={20_000}
                        onChange={(e) => setParameterFilter({ name: "radius", value: e.target.value })}
                    />
                </div>
            </div>
        </>
    );
}
